import { di } from 'react-magnetic-di';
import {
    useMessageDialogActions,
    MESSAGE_DIALOG_TYPE
} from '@codexporer.io/fluent-ui-message-dialog';
import {
    useAppAnalytics,
    EventName
} from '@race-planner-web/app-analytics-bridge';

export const useUnexpectedInputErrorDialog = () => {
    di(useAppAnalytics, useMessageDialogActions);

    const [, { open, close }] = useMessageDialogActions();
    const { sendEvent } = useAppAnalytics();

    return {
        openUnexpectedInputErrorDialog: ({ message }) => open({
            title: 'Unexpected Input',
            message,
            type: MESSAGE_DIALOG_TYPE.error,
            actions: [
                {
                    id: 'okButton',
                    handler: close,
                    text: 'Ok',
                    isPrimary: true
                }
            ],
            onOpen: () => sendEvent({
                name: EventName.openUnexpectedInputErrorDialog,
                attributes: { error_message: message }
            })
        })
    };
};
